import { styled, FormControlLabel } from "@mui/material";
const RadioFormControlLabel = styled(FormControlLabel)(
  ({ theme }) => ({
    marginLeft: 0,
    marginRight: 0,
    padding: theme.spacing(1.5, 2),
    "&:not(:first-of-type)": {
      borderTopWidth: 0.5,
      borderTopStyle: "solid",
      borderTopColor: theme.palette.grey[300]
    }
  })
);
export {
  RadioFormControlLabel
};
